import { Box, styled, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: theme.palette.background.neutral,
        backgroundImage: `url(/assets/img/cyan-blur.png), url(/assets/img/red-blur.png)`,
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundSize: '50%, 50%',
        backgroundPosition: 'right top, left bottom',
      }}
    >
      <Outlet />
    </Box>
  );
}
